import { createApp } from 'vue'
import StreamDonationOverviewNewDonation from './StreamDonationOverviewNewDonation'

const el = '.kb-component--stream-donation-overview-new-donation'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StreamDonationOverviewNewDonationDOM) => {
            const component = createApp(StreamDonationOverviewNewDonation).use(Store)
            component.mount(StreamDonationOverviewNewDonationDOM)
        })
    }
}
